import * as React from "react";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import Button from "./Button";
import Text from "./Text";

import medium from "./medium.jpg";
import youtube from "./youtube.jpg";

type ClassNames = "container" | "child" | "medium" | "youtube" | "content" | "emptyContent";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        display: "flex",
        [theme.breakpoints.down("md")]: {
            width: "100%",
            flexDirection: "column"
        }
    },
    child: {
        flex: 1,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        height: 350,
        padding: theme.spacing.unit * 2,
        display: "flex",
        flexDirection: "row",
        color: "white"
    },
    content: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start"
    },
    emptyContent: {
        display: "flex",
        flex: 1,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            display: "none"
        }
    },
    medium: {
        backgroundImage: `linear-gradient(90deg, black 10%, transparent), url(${medium})`,

    },
    youtube: {
        backgroundImage: `linear-gradient(90deg, black 10%, transparent), url(${youtube})`,
    }
});

interface ResourcesProps {
    noop?: boolean
}

class Resources extends React.Component<WithStyles<ClassNames> & ResourcesProps> {
    public render() {
        const {classes} = this.props;
        return (
            <div className={classes.container}>
                <div className={`${classes.child} ${classes.medium}`}>
                    <div className={classes.content}>
                        <Text variant="title3" color="inherit">Read stories</Text>
                        <Text color="inherit">
Building these starter kits has inspired us to share tips with the community about React Native development.
                        </Text>
                        <Button
                            href="https://medium.com/@wcandillon"
                            target="_blank"
                            contrast={true}
                        >
                        Medium Stories
                        </Button>
                    </div>
                    <div className={classes.emptyContent} />
                </div>
                <div className={`${classes.child} ${classes.youtube}`}>
                    <div className={classes.content}>
                        <Text variant="title3" color="inherit">
                        Watch how it's made
                        </Text>
                        <Text color="inherit">
                        Some of these kits have been coded live on YouTube.
                        See how it's being made and get inspired to build beautiful apps.
                        </Text>
                        <Button
                            href="https://www.youtube.com/channel/UC806fwFWpiLQV5y-qifzHnA"
                            target="_blank"
                            contrast={true}
                        >
                        Youtube Channel
                        </Button>
                    </div>
                    <div className={classes.emptyContent} />
                </div>
            </div>
        );
    }
}

export default withStyles(styles)<ResourcesProps>(Resources);



// WEBPACK FOOTER //
// ./src/components/Resources.tsx